import axios from 'axios';
import { auth } from '../firebase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const isLocalhost = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
};

export const trackUserEvent = async (eventType, eventName, metadata = {}) => {
  const safeEventType = String(eventType || 'UNKNOWN');
  const safeEventName = String(eventName || 'Unknown Event');
  const safeMetadata = metadata && typeof metadata === 'object' ? metadata : {};

  if (isLocalhost()) {
    // eslint-disable-next-line no-console
    console.log('[Telemetry][local]', {
      eventType: safeEventType,
      eventName: safeEventName,
      metadata: safeMetadata,
    });
    return;
  }

  const user = auth.currentUser;
  if (!user) return;

  try {
    const token = await user.getIdToken();
    await axios.post(
      `${API_BASE_URL}/activity/log`,
      {
        eventType: safeEventType,
        eventName: safeEventName,
        metadata: safeMetadata,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    // Telemetry failures should not block user actions.
  }
};

export default trackUserEvent;
